export default __webpack_public_path__ + "static/5-73871bd47c48a831d1ac2213b055c224.jpeg";